module.exports = __webpack_public_path__ + "static/media/tab-explore.484eafc5.svg";